const authRoutes: (string | RegExp)[] = ['/login']
const publicRoutes: (string | RegExp)[] = ['/redirects/*']
const tenantRoutes: (string | RegExp)[] = [
  '/wizard/tenants/create',
  '/wizard/tenants/find',
]

import { useAuth } from '../composables/useAuth'

const isAuthRoute = (route: string) =>
  authRoutes.some((x) =>
    typeof x === 'string' ? route === x : (x?.test(route) ?? false),
  )

const isPublicRoute = (route: string) =>
  publicRoutes.some((x) =>
    typeof x === 'string' ? route === x : (x?.test(route) ?? false),
  )

const isTenantRoute = (route: string) =>
  tenantRoutes.some((x) =>
    typeof x === 'string' ? route === x : (x?.test(route) ?? false),
  )

export default defineNuxtRouteMiddleware(async (to, _from) => {
  const api = useApi()
  const auth = useAuth()
  const localStorageLoginHint = useLocalStorage('loginHint', '')
  const localStorageName = useLocalStorage('name', '')

  console.log(auth.user, isAuthRoute(to.path), isPublicRoute(to.path))

  // Allow 404 page to show
  console.log(to.matched.length)
  if (!to.matched.length) return
  if (isPublicRoute(to.path)) {
    return
  }

  if (!auth.user && !isAuthRoute(to.path)) {
    console.log('redirecting to login')
    return navigateTo('/login')
  }
  if (auth.user && isAuthRoute(to.path)) {
    if (authRoutes.includes(to.path)) return navigateTo('/')
  }

  // await auth.getPromise()
  if (auth.user && !auth.user?.tenantId && !isTenantRoute(to.path)) {
    return navigateTo('/wizard/tenants/find')
  }
  if (auth.user?.tenantId && isTenantRoute(to.path)) {
    return navigateTo('/')
  }
})
